import BlockType from "./BlockType";

export default BlockType;
